import { useMemo } from "react";
import { formatMoney } from "infra/helpers/number";
import moment from "moment";
import { Box } from "@chakra-ui/react";
import { RelatorioReservasItem } from "core/features/relatorios/typings/index";
import { Flex } from "@chakra-ui/layout";
import TagStatus from "./components/TagStatus";
import colors from "core/resources/theme/colors";
import { TagStatusReserva } from "components/Tags/TagStatusReserva";

function useRelatorioReservasTableColumns() {
  return useMemo(() => {
    return [
      {
        title: "Data de criação",
        width: "100px",
        render: (item: RelatorioReservasItem) => (
          <Box>
            <Flex>
              {item.createdAt
                ? moment(item.createdAt).format("DD/MM/YYYY")
                : "--"}
            </Flex>
            <TagStatus
              titulo={item.origem?.toLocaleUpperCase()}
              color={colors.blue}
            />
          </Box>
        ),
      },
      {
        title: "Data do evento",
        width: "100px",
        render: (item: RelatorioReservasItem) => (
          <Box>
            <Flex>
              {item.dataEvento
                ? moment(item.dataEvento).format("DD/MM/YYYY")
                : "--"}
            </Flex>
            <Flex fontSize="12px">
              {item.dataEvento
                ? moment(item.horaInicio, "hhmms").format("HH:mm")
                : "--"}
            </Flex>
          </Box>
        ),
      },

      {
        title: "Área comum",
        width: "110px",
        render: (item: RelatorioReservasItem) =>
          item.areaComum ? item.areaComum : "--",
      },
      {
        title: "Valor",
        width: "60px",
        render: (item: RelatorioReservasItem) =>
          item.valor ? formatMoney(item.valor) : "--",
      },
      {
        title: "Responsável",
        width: "110px",
        render: (item: RelatorioReservasItem) => (
          <Box>
            <Flex>{item.proprietario ? item.proprietario : "--"}</Flex>
            <Flex fontSize="12px">
              {item.unidade ? item.unidade : "--"}
              {item?.blocoQuadra ? ` - ${item.blocoQuadra.nome}` : ""}
            </Flex>
          </Box>
        ),
      },
      {
        title: "Status",
        width: "80px",
        render: (item: RelatorioReservasItem) => (
          <Flex>
            <TagStatusReserva statusId={item.status} />
          </Flex>
        ),
      },
      {
        title: "Data de cancelamento",
        width: "80px",
        render: (item: RelatorioReservasItem) => (
          <Box>
            <Flex>
              {item.dataCancelamento
                ? moment(item.dataCancelamento).format("DD/MM/YYYY")
                : "--"}
            </Flex>
            <Flex fontSize="12px">
              {item.dataCancelamento
                ? moment(item.dataCancelamento).format("HH:mm")
                : null}
            </Flex>
          </Box>
        ),
      },
      {
        title: "Quem cancelou",
        width: "110px",
        render: (item: RelatorioReservasItem) => (
          <Flex>
            <Flex>
              {item.responsavelCancelamento
                ? item.responsavelCancelamento.nome
                : "--"}
            </Flex>
          </Flex>
        ),
      },
    ];
  }, []);
}

export default useRelatorioReservasTableColumns;
